<!-- <div class="col-lg-12 padding-left-0 d-flex ">  
    <h6 class="text-left margin-right-7 margin-right-10 fw-600">
     <span> {{field.templateOptions.label}}</span> 
    </h6>
    <div class="custom-control custom-switch text-right position-relative top--35px">
        <input type="checkbox" checked class="custom-control-input" id="{{ 'cbx' + fieldKey }}" [checked]="formControl.value"
        [formControl]="formControl" (input)="onValueChange()" [disabled]="field.templateOptions.disabled">

        <label [ngClass]="{'bigToggle': enableBigToggle}" class="custom-control-label cursor-pointer f-14 fw-600 lH-25 padding-left-5" for="{{ 'cbx' + fieldKey }}"></label>

    </div>
</div> -->

@if (hasDescription) {
    <div class="dfs-jcs flex-row">
        <div>
            <h6 class="title-14">{{ titleLabel }}</h6>
            <!-- Guarded: a title with no description would otherwise leave an empty paragraph
                 taking a line of height under it. -->
            @if (description) {
                <p class="paragraph-14 text-placeholder">{{ description }}</p>
            }
        </div>
        <ds-toggel
            [formControl]="formControl"
            [toggleInput]="toggleConfig"
            (isActiveChange)="onValueChange($event)"
        ></ds-toggel>
    </div>
} @else {
    <!-- Alignment classes only bite when the field asks for them, so a toggle standing on its own
         keeps its natural height. `withInputLabel` wins if both are set - the taller row is the
         one that has to be matched. -->
    <div [ngClass]="withInputLabel ? 'toggel-align--input-label' : (withInput ? 'toggel-align--input' : '')">
        <ds-toggel
            [formControl]="formControl"
            [toggleInput]="toggleConfig"
            (isActiveChange)="onValueChange($event)"
        ></ds-toggel>
    </div>
}